import * as _ from 'lodash';

export function deleteUndefinedKeysInObject(object: unknown) {
  const obj = Object.assign({}, object);
  for (const key of Object.keys(obj)) {
    if (obj[key] === undefined || obj[key] === null) {
      delete obj[key];
    }
    if (Array.isArray(obj[key])) {
      if (obj[key].length > 0) {
        for (let i = 0; i < obj[key].length; i++) {
          console.log(obj[key][i]);
          obj[key][i] = Object.assign({}, this.deleteUndefinedKeys(obj[key][i]));
        }
      }
    }
  }
  return obj;
}


export function removeProperty<T extends object>(obj: T, key: keyof T): void {
  if (key in obj) {
    delete obj[key];
  }
}

// Verify if all the properties of an object are null
export function isObjectAllPropertiesNull(obj: any) {
  const isEmpty = Object.values(obj).every(x => x === null);
  return isEmpty;
}

// Change to replace common js util isNullOrUndefined  required by angular 12
export function isNullOrUndefined(obj: any) {
  return (obj === undefined || obj === null)
}

export function isEmpytObject(obj) {
 return  Object.keys(obj).length === 0
}
export function isNotNullOrUndefinedOrEmpty(obj: any) {
  return (obj !== undefined && obj !== null && obj !== "")
}


export function isNullOrUndefinedOrEmpty(obj: any) {
  return (obj == undefined || obj == null || obj == "")
}
// Change to replace common js util isUndefined  required by angular 12
export function isUndefined(obj: any) {
  return (obj === undefined )
}

export function isEmptyOrAllNull(obj: any) {
  // Speed up calls to hasOwnProperty
  //const hasOwnProperty = Object.prototype.hasOwnProperty;

  // null and undefined are "empty"
  if (obj === null || obj === undefined) return true;

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== "object") return true;

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (const key in obj) {
    if (/*hasOwnProperty.call(obj, key) && */obj[key] !== null && obj[key] !== undefined) return false;
  }

  return true;
}

export function removePropsFrom<T extends Object>(obj: T, propsToRemove: string[]): T {
  var objClone = _.clone(obj);
  for (var key in objClone) {
    if (propsToRemove.indexOf(key) != -1)
      delete objClone[key];
  }
  return objClone;
};

export function CurrencyFormat(inputString) {
  if (isNullOrUndefined(inputString)) {
    inputString = "";
  }
  else {
    inputString = inputString.toString();
    inputString = inputString.replace(/ /g, "");
    inputString = inputString.replace(/\./g, ",");
  }

  var decimalPart = "";
  if (inputString.indexOf(',') != -1) {
    inputString = inputString.split(",");
    decimalPart = "," + (inputString[1] == "" ? "00" : (inputString[1] + "00").substring(0, 2));
    inputString = inputString[0];
  }
  else {
    decimalPart = inputString == "" ? "" : ",00";
  }

  var outputString = "";
  var count = 0;
  for (var i = inputString.length - 1; i >= 0 && inputString.charAt(i) != '-'; i--) {
    if (count == 3) {
      outputString += " ";
      count = 0;
    }
    outputString += inputString.charAt(i);
    count++;
  }
  if (inputString.charAt(0) == '-') {
    outputString += "-";
  }

  return outputString.split("").reverse().join("") + decimalPart;
}

export function isTruthy(value: unknown): boolean {
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();

    // Strings explicitamente verdadeiras
    if (["True", "true", "1", "yes", "y"].includes(normalized)) {
      return true;
    }

    // Strings explicitamente falsas
    if (["False", "false", "0", "no", "n"].includes(normalized)) {
      return false;
    }

    // Caso não seja uma dessas, usa o comportamento original
    return normalized.length > 0;
  }

  // Números
  if (typeof value === "number") {
    return value === 1 || value === -1 || !!value;
  }

  // Qualquer outro tipo → comportamento JS
  return !!value;
}
